var animascroll;

animascroll = function() {
  var $, Typed, isTyped, module, moduleName;
  $ = require('jquery');
  Typed = require('typed.js');
  isTyped = false;
  moduleName = 'animascroll';
  module = $("." + moduleName);
  if (module.length !== 0) {
    return module.each(function() {
      var initActions, scrollClickIterations, scrollIterations, thisAfter, thisDelay, thisElemData, thisLoadData, thisLoadIdData, thisMaxWidth, thisMinWidth, thisMod, thisOffBottom, thisOffset, thisScrollToData;
      thisMod = $(this);
      thisAfter = thisMod.data('after');
      thisElemData = thisMod.data('svg');
      thisOffBottom = thisMod.data('off');
      thisMaxWidth = thisMod.data('maxwidth');
      thisMinWidth = thisMod.data('minwidth');
      thisDelay = thisMod.data('delay');
      thisLoadData = thisMod.data('load');
      thisLoadIdData = thisMod.data('load-id');
      thisOffset = thisMod.offset().top;
      thisScrollToData = thisMod.data('scrollto');
      scrollClickIterations = 0;
      scrollIterations = 0;
      initActions = function() {
        var initAutoScroll, initMainActions, isLoadedBefore, linkClick, paramWidth, thisScrollScope, winOffBottom;
        if (thisMaxWidth || thisMinWidth) {
          paramWidth = function(param) {
            var winWidth;
            winWidth = $(window).width();
            if (param) {
              if (param > winWidth) {
                return false;
              }
            }
          };
          if (thisMaxWidth && paramWidth(thisMaxWidth) === false) {
            return false;
          }
          if (thisMinWidth && paramWidth(thisMinWidth) === false) {
            return false;
          }
        }
        if (thisScrollToData) {
          thisScrollScope = thisMod.parents('[data-scrollscope]');
          initAutoScroll = function(scrollBlock, scrollToElem) {
            var scrollNum;
            if (scrollIterations < 1) {
              scrollNum = document.querySelector("." + scrollToElem).getBoundingClientRect().top - thisScrollScope.height() + thisMod.outerHeight() + 30;
              scrollBlock.animate({
                scrollTop: scrollNum
              }, 300);
            }
            return scrollIterations++;
          };
          if (scrollClickIterations < 1) {
            thisMod.one('click', function() {
              if (thisScrollScope) {
                scrollClickIterations++;
                initAutoScroll(thisScrollScope, thisScrollToData);
              } else {
                initAutoScroll($('body'), thisScrollToData);
              }
              return scrollClickIterations = 0;
            });
          }
        }
        if (thisLoadData && thisLoadIdData) {
          isLoadedBefore = localStorage.getItem("" + thisLoadIdData);
          linkClick = false;
          $('a[href]').click(function() {
            return linkClick = true;
          });
          $(window).on("beforeunload", function(e) {
            if (linkClick) {

            } else {
              return localStorage.removeItem("" + thisLoadIdData);
            }
          });
          if (isLoadedBefore !== null) {
            thisMod.removeClass(function() {
              var classes, i, results, toReturn;
              toReturn = '';
              classes = this.className.split(" ");
              i = 0;
              results = [];
              while (i < classes.length) {
                if (/animascroll--([\s\S]{1,99})/.test(classes[i])) {
                  toReturn += classes[i] + " ";
                  $(this).removeClass(toReturn);
                }
                results.push(i++);
              }
              return results;
            });
            return false;
          } else {
            localStorage.setItem("" + thisLoadIdData, "" + thisLoadData);
          }
        }
        if (thisOffBottom) {
          winOffBottom = $(window).scrollTop() + $(window).height() - parseInt(thisOffBottom);
        } else {
          winOffBottom = $(window).scrollTop() + $(window).height();
        }
        initMainActions = function() {
          var initTyped, thisDataFirstWrite, thisDataLastWrite, thisElem, thisSvg;
          if (winOffBottom > thisOffset) {
            thisMod.not('[data-after]').addClass(moduleName + "--enabled");
            if (thisMod.hasClass(moduleName + "--typed") && thisMod.hasClass(moduleName + "--enabled") && isTyped === false) {
              thisDataFirstWrite = thisMod.data("write-first");
              thisDataLastWrite = thisMod.data("write-last");
              thisMod.html();
              initTyped = new Typed("." + moduleName + "--typed", {
                strings: [thisDataFirstWrite, thisDataLastWrite],
                typeSpeed: 100,
                startDelay: 100,
                cursorChar: '',
                preStringTyped: function(arrayPos, self) {
                  return self.cursorChar = "_";
                },
                onComplete: function(self) {
                  return self.cursorChar = "";
                }
              });
              isTyped = true;
            }
          }
          if (thisAfter && $("." + thisAfter).hasClass(moduleName + "--enabled")) {
            setTimeout(function() {
              return thisMod.addClass(moduleName + "--enabled");
            }, 1000);
          }
          if (thisElemData && thisMod.hasClass(moduleName + "--enabled")) {
            thisSvg = thisMod.find('svg');
            if (thisSvg.hasClass("ended")) {
              return false;
            } else {
              thisElem = document.getElementById(thisElemData);
              if (thisElem) {
                thisElem.beginElement();
                return thisSvg.addClass('ended');
              }
            }
          }
        };
        if (thisDelay) {
          return setTimeout(function() {
            return initMainActions();
          }, parseInt(thisDelay));
        } else {
          return initMainActions();
        }
      };
      $(document).ready(function() {
        return initActions();
      });
      return $(window).scroll(function() {
        return initActions();
      });
    });
  }
};

module.exports = animascroll;
